import React, { useCallback } from 'react';

import { Select } from 'components/ui/select';

type SelectProps = React.ComponentProps<typeof Select>;
type Props = Omit<SelectProps, 'onChange'> & {
  onChange: (changes: Record<string, SelectProps['value']>) => void;
  onValueChange: (value: SelectProps['value']) => void;
}

export default function ManagedReactSelectInput({ name, onChange, onValueChange, ...props }: Props) {
  const handleChange: SelectProps['onChange'] = useCallback((value) => {
    if (name) {
      onChange({ [name]: value });
    }

    onValueChange(value);
  }, [name, onChange, onValueChange]);

  // The cast is needed as Omit<UnionType, 'key'> doesn't spread back onto union-typed components
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <Select {...props as any} onChange={handleChange} />;
}
